import { render, staticRenderFns } from "./CreateNewMockup.vue?vue&type=template&id=25a228f6&scoped=true"
import script from "./CreateNewMockup.vue?vue&type=script&lang=js"
export * from "./CreateNewMockup.vue?vue&type=script&lang=js"
import style0 from "./CreateNewMockup.vue?vue&type=style&index=0&id=25a228f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25a228f6",
  null
  
)

export default component.exports